import { useContext } from "react";
import { UsuarioContext } from "@/contexts/UsuarioContext";

export function useAuth() {
  const context = useContext(UsuarioContext);
  if (context === undefined) {
    throw new Error("useAuth deve ser usado dentro de um UsuarioProvider");
  }
  return context;
}
